export default "__VITE_ASSET__D2pjoWx4__"